import { render, staticRenderFns } from "./naver-pay.vue?vue&type=template&id=7c6d0ac0&"
import script from "./naver-pay.vue?vue&type=script&lang=js&"
export * from "./naver-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports